/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Missing_TitleInputs */

const fr_marker_missing_title = /** @type {(inputs: Marker_Missing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrée introuvable`)
};

const en_marker_missing_title = /** @type {(inputs: Marker_Missing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entry not found`)
};

/**
* | output |
* | --- |
* | "Entry not found" |
*
* @param {Marker_Missing_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const marker_missing_title = /** @type {((inputs?: Marker_Missing_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Missing_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_marker_missing_title(inputs)
	return en_marker_missing_title(inputs)
});